import { Palette } from '@/themes/themeOverrides/Palette';

export const AD_STATUS = {
    SCHEDULED: 'scheduled',
    ONGOING: 'ongoing',
    ENDED: 'ended',
};

const AD_STATUS_LABEL_KEYS = {
    [AD_STATUS.SCHEDULED]: 'resources.adsCampaign.labels.scheduled',
    [AD_STATUS.ONGOING]: 'resources.adsCampaign.labels.ongoing',
    [AD_STATUS.ENDED]: 'resources.adsCampaign.labels.finished',
};

export const getAdStatusLabel = (status, translate) => {
    const labelKey = AD_STATUS_LABEL_KEYS[status];
    return labelKey ? translate(labelKey) : status;
};

export const getAdStatusColor = status => {
    switch (status) {
        case AD_STATUS.ONGOING:
            return Palette.green.green100;
        case AD_STATUS.SCHEDULED:
            return Palette.violet.violet100;
        case AD_STATUS.ENDED:
            return Palette.gray.green100;
        default:
            return Palette.gray.gray300;
    }
};

export const isAdStatusOngoing = status => status === AD_STATUS.ONGOING;

export const isAdStatusEnded = status => status === AD_STATUS.ENDED;

export const isAdStatusEditable = status => status === AD_STATUS.SCHEDULED || status === AD_STATUS.ONGOING;

export const getAdStatusChoices = translate =>
    Object.values(AD_STATUS).map(status => ({
        id: status,
        name: getAdStatusLabel(status, translate),
    }));

export const AD_STATUS_FILTER_DEFAULT = Object.values(AD_STATUS);
